<ngx-alerts></ngx-alerts>
<div class="row col-12 d-flex justify-content-center pr-0 pr-md-1">
  <div class="col-12 col-md-5 d-flex justify-content-center pr-0 pr-md-1">
    <mat-card class="col-12 ">
      <div class="d-flex justify-content-center">
        <img mat-card-image style="height: 150px;width: 150px" class="rounded-circle mt-1"
             [src]="userDetails?.userImg|| 'assets/icons/user.svg'">
      </div>
      <mat-card-content>
        <div class="pl-0 pl-md-3 pr-0 pr-md-3">
          <div class="d-flex justify-content-between">
            <span><b>Name</b></span>
            <span class="text-left">{{userDetails?.userFullName}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span><b>Email</b></span>
            <span class="text-left">{{userDetails?.userEmail}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span><b>Phone Number</b></span>
            <span class="text-left">{{userDetails?.userPhoneNumber}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span><b>Address</b></span>
            <span class="text-wrap text-left"
                  style="max-width: 190px!important;">{{userDetails?.userAddresses && userDetails?.userAddresses.length ?
              getAddress(userDetails?.userAddresses[0]) : ''}}</span>
          </div>
        </div>
        <br>
        <div class="text-center">
          <h4 class=" font-weight-bold mb-0">Bank Details </h4>
          <p class=" mb-0 text-danger"><small>Payments will be sent to this account</small></p>
        </div>
        <div class="row col-12 d-flex justify-content-around pr-0" [formGroup]="dataForm">
          <mat-form-field class="col-12 col-md-6 pl-0 pr-0 pl-md-2 pr-md-2">
            <mat-label required="">Account Holder Name</mat-label>
            <input matInput placeholder="Account Holder Name" required formControlName="accountHoldersName"
                   [ngClass]="{ 'is-invalid': dataFormSubmitted && dataForm.controls.accountHoldersName.errors }">
          </mat-form-field>
          <mat-form-field class="col-12 col-md-6 pl-0 pr-0 pl-md-2 ">
            <mat-label required>Account No.</mat-label>
            <input matInput formControlName="accountNo" placeholder="Enter Bank Account No." required
                   [ngClass]="{ 'is-invalid': dataFormSubmitted && dataForm.controls.accountNo.errors }">
          </mat-form-field>
          <mat-form-field class="col-12 col-md-6 pl-0 pr-0 pl-md-2 pr-md-2">
            <mat-label required>IFSC Code</mat-label>
            <input matInput placeholder="Enter Bank IFSC Code" formControlName="ifscCode" required
                   (focusout)="onIFSCChange()" (keypress)="onKeyPress($event.key)"
                   [ngClass]="{ 'is-invalid': isShowIFSCError ||( dataFormSubmitted && dataForm.controls.accountNo.errors)}"
                   minlength="4">
            <span class="text-danger" *ngIf="isShowIFSCError">Invalid IFSC Code</span>
          </mat-form-field>
          <mat-form-field class="col-12 col-md-6 pl-0 pr-0 pl-md-2 " appearance="fill">
            <mat-label>Bank Name</mat-label>
            <input matInput placeholder="Bank Name" formControlName="bankName" readonly
                   [ngClass]="{ 'is-invalid': dataFormSubmitted && dataForm.controls.bankName.errors }">
          </mat-form-field>
          <mat-form-field class="col-12 col-md-6 pl-0 pr-0 pl-md-2 pr-md-2" appearance="fill">
            <mat-label>Branch Name</mat-label>
            <input matInput placeholder="Branch Name" formControlName="branchName" readonly
                   [ngClass]="{ 'is-invalid': dataFormSubmitted && dataForm.controls.branchName.errors }">
          </mat-form-field>
          <mat-form-field class="col-12 col-md-6 pl-0 pr-0 pl-md-2 ">
            <mat-label>GST No.</mat-label>
            <input matInput placeholder="Gst No." formControlName="gstNo">
          </mat-form-field>
        </div>


        <!--        <div class="text-center">-->
        <!--          <h4 class="font-weight-bold">Wallet Details</h4>-->
        <!--        </div>-->
        <!--        <div class="d-flex justify-content-between">-->
        <!--          <span><b>Available Amount</b></span>-->
        <!--          <span class="text-left">₹ {{userDetails?.userWallet.amount}}</span>-->
        <!--        </div>-->
        <!--        <div class="d-flex justify-content-between">-->
        <!--          <span [matTooltip]="'Amount debt to the company'" class="pointer"><b>Payable Amount<span-->
        <!--            class="helper"></span> </b>-->
        <!--        </span>-->
        <!--          <span class="text-left font-weight-bold"-->
        <!--                [matTooltip]="'Amount debt to the company'"-->
        <!--                class="pointer">₹ {{userDetails?.userWallet.debtAmount}}</span>-->
        <!--        </div>-->
        <!--        <div class="d-flex justify-content-between">-->
        <!--          <span><b>Amount Earned from Commission</b></span>-->
        <!--          <span>₹ {{userDetails?.userWallet.commission}}</span>-->
        <!--        </div>-->
        <!--        <div class="d-flex justify-content-between">-->
        <!--          <span><b>Referral Amount</b></span>-->
        <!--          <span class="text-left">₹ {{userDetails?.userWallet.referralEarnings}}</span>-->
        <!--        </div>-->
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="onRaiseTickerClick()"><a href="javascript:void(0)"
                                                             class="text-danger">Raise Complaint</a></button>
        <button mat-button class="btn btn-solid-blue" (click)="onAccountDetailsUpdateClick()">Submit</button>
      </mat-card-actions>
    </mat-card>
  </div>


  <div class="col-12 pt-4 pt-md-0 col-md-7 pr-0 pr-md-1"
       *ngIf="(userType.toLowerCase() == 'drivingschool')">
    <mat-card class="col-12">
      <mat-card-header class="text-center">
        <mat-card-title>Business Profile</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="businessProfileForm" class="col-12 p-0">
          <div class="row">
            <mat-form-field class="col-12 col-sm-6">
              <mat-label>Driving School Name</mat-label>
              <input matInput formControlName="businessName" placeholder="Driving School Name">
            </mat-form-field>
            <mat-form-field hintLabel="Max 10 characters" class="col-12 col-sm-6">
              <mat-label>Contact Number</mat-label>
              <input matInput mask="0000000000" formControlName="contactNumber" placeholder="9876543210">
            </mat-form-field>
            <mat-form-field class="col-12 col-sm-6">
              <mat-label>Address</mat-label>
              <textarea matInput formControlName="address" placeholder="Address"></textarea>
            </mat-form-field>
          </div>
          <br>
          <div class="row">
            <div class="col-12 col-md-8 pl-md-0">
              <mat-label class="pl-3">Shop Image</mat-label>
              <div class="col-md-11 mt-2 border-box d-flex justify-content-center align-items-center pointer"
                   (click)="imageInput.click()" *ngIf="!selectedFile &&( !this.businessProfileForm ||
          !this.businessProfileForm.value.imageUrl)">
                <div class="d-block text-center align-items-center ">
                  <input class="hide" #imageInput type="file" accept=".jpg,.jpeg,.png" (change)="onImageUpload($event)">
                  <a href="javascript:void(0)" class="text-grey"><i class="fa fa-cloud-upload-alt fa-2x"
                                                                    aria-hidden="true"></i></a>
                  <div class="text-grey">Upload Shop Image</div>
                </div>
              </div>
              <div class=" col-md-11 mt-2 image-area" *ngIf="selectedFile ||(this.businessProfileForm &&
          this.businessProfileForm.value.imageUrl)">
                <img
                  [src]="this.businessProfileForm&&this.businessProfileForm.value?.imageUrl || selectedFile.fileContent"
                  alt="Preview">
                <a class="remove-image" href="javascript:void(0)" [matTooltip]="'Remove the Image'"
                   style="display: inline;"
                   (click)="selectedFile=undefined;this.businessProfileForm.get('imageUrl').setValue('')">&#215;</a>
              </div>
            </div>
            <!--            <div class="col-12 col-md-6">-->
            <!--              <section>-->
            <!--                <b>Select Available Timings</b>-->
            <!--              </section>-->
            <!--              <table>-->
            <!--                <thead>-->
            <!--                <th class="row">-->
            <!--                  <tr class=" col-12 d-flex justify-content-between">-->
            <!--                    <td class="col-12">Day</td>-->
            <!--                    <td class="col-12"><span class="text-right">Timings</span></td>-->
            <!--                  </tr>-->
            <!--                </th>-->
            <!--                </thead>-->
            <!--                <tbody>-->
            <!--                <tr>-->
            <!--                  <td>Monday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Tuesday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Wednesday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Thursday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Friday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Saturday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                <tr>-->
            <!--                  <td>Sunday</td>-->
            <!--                  <ng-multiselect-dropdown-->
            <!--                    [placeholder]="'Select Timings'"-->
            <!--                    [settings]="dropdownSettings"-->
            <!--                    [data]="dropdownList"-->
            <!--                    [(ngModel)]="selectedItems"-->
            <!--                    (onSelect)="onItemSelect($event)"-->
            <!--                    (onSelectAll)="onSelectAll($event)"-->
            <!--                  >-->
            <!--                  </ng-multiselect-dropdown>-->
            <!--                </tr>-->
            <!--                </tbody>-->
            <!--              </table>-->
            <!--            </div>-->
          </div>
          <!--          <div class="row">-->
          <!--            <div class="col-12 col-md-6">-->
          <!--              <label for="shopUrl">Your Shop website Link</label>-->
          <!--              <div class="input-group mb-3" id="shopUrl">-->
          <!--                <input type="text" class="form-control" placeholder="Your Shop website Link"-->
          <!--                       aria-label="Shop website link" [value]="websiteLink"-->
          <!--                       aria-describedby="basic-addon2" readonly>-->
          <!--                <div class="input-group-append">-->
          <!--                  <span class="input-group-text" id="basic-addon2"><i class="fas fa-copy pointer"-->
          <!--                                                                      [matTooltip]="'Copy to clipboard'"-->
          <!--                                                                      [cdkCopyToClipboard]="websiteLink"></i></span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="col-12 col-md-6">-->
          <!--              <qrcode [qrdata]="websiteLink" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>-->
          <!--            </div>-->
          <!--          </div>-->
        </form>
      </mat-card-content>
      <mat-card-actions class="d-flex justify-content-center">
        <button mat-button class="btn btn-solid-blue" (click)="onSubmitClick()">Submit</button>
      </mat-card-actions>
    </mat-card>
  </div>

</div>
